import { aquaAxios, callAsyncWithRetry } from 'lib/utilityFunctions';
import { setGameLevelConceptMap } from 'a/actions/persistStateActions';

import { CONTENT_SERVICE_URL } from './endpoints';

const getEMGames = () => async (dispatch, getState) => callAsyncWithRetry(
  async () => {
    try {
      const { persistStateReducer: { skillMap } } = getState();
      const { data } = await aquaAxios(`${CONTENT_SERVICE_URL}/gameLevelConceptMap?skillMap=${skillMap}`);
      dispatch(setGameLevelConceptMap(data.ConceptMap));
    } catch (error) {
      Promise.reject(error);
    }
  },
  {
    logger: (_, { isDoneRetrying }) => {
      if (isDoneRetrying) {
        console.error('Could not retrieve GameLevelConceptMap');
      }
    },
  },
);

export default getEMGames;
